import Api from '../../../services/Api';
import { ApiResponse } from 'apisauce';
import {
  ISetting,
  IWorkflow,
  IWorkflowStep,
  IWorkflowTrigger,
} from '../business-objects/common';
import { toast } from 'react-toastify';
import * as actionTypes from './actionTypes';

export const getWorkflows = (url: string) => {
  return async (dispatch) => {
    try {
      await Api.get(url).then((response: ApiResponse<any>) => {
        dispatch(reduceWorkflows(response.data));
        return Promise.resolve(response.data);
      });
    } catch (ex) {
      console.log(ex);
      return Promise.reject(ex);
    }
  };
};

export const reduceWorkflows = (workflows: IWorkflow[]) => {
  return {
    type: actionTypes.GET_WORKFLOWS,
    value: workflows,
  };
};

export const saveWorkflow = (url: string, workflow: IWorkflow) => {
  return async (dispatch) => {
    try {
      await Api.post(url, workflow).then((response: ApiResponse<any>) => {
        if (response.ok) {
          toast.success('Saved!');
          //console.log('saved workflow and returned: ', response.data);
        } else {
          toast.error('Error! Check logs');
        }
      });
    } catch (ex) {
      console.log(ex);
    }
  };
};

export const getApplicationSetting = (url: string) => (dispatch) =>
  new Promise(function (resolve, reject) {
    try {
      Api.get(url).then((response: ApiResponse<any>) => {
        if (response.ok) {
          return resolve(response.data);
        } else {
          console.log('error retrieving setting');
          return reject();
        }
      });
    } catch (ex) {
      return reject(ex);
    } finally {
      //return Promise.resolve();
    }
  });

export const saveApplicationSetting = (url: string, setting: ISetting) => (
  dispatch
) =>
  new Promise(function (resolve, reject) {
    try {
      Api.post(url, setting).then((response: ApiResponse<any>) => {
        if (response.ok) {
          return resolve(response.data);
        } else {
          console.log('error saving setting');
          return reject();
        }
      });
    } catch (ex) {
      return reject(ex);
    } finally {
    }
  });